<span class="row">
	<mat-form-field>
		<mat-label>{{ "MAIN_APP_SERVICE_APP.filter" | translate }}</mat-label>
		<input #input [formControl]="searchString" matInput placeholder="Begriff eingeben"/>
	</mat-form-field>
</span>

<span [ngClass]="{'lightweight': lightweight}">
	<table *ngIf="!lightweight else lightweightList" [dataSource]="products" class="mat-elevation-z8" mat-table>
		<!-- Artikel-Nr. Column -->
		<ng-container matColumnDef="productNo">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_SERVICE_APP.artikelnummer" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>{{ element.productNo }}</td>
		</ng-container>
		
		<!-- Bezeichnung Column -->
		<ng-container matColumnDef="description">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_SERVICE_APP.bezeichnung" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>{{ element.shortText }}</td>
		</ng-container>
		
		<!-- Preis pro Einheit Column -->
		<ng-container matColumnDef="pricePerQuantity">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_SERVICE_APP.preisLagereinheit" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				{{ element.salePrice }} / {{ element.stockUnit }}
			</td>
		</ng-container>
		
		<!-- Suchbegriff Column -->
		<ng-container matColumnDef="searchKey">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_SERVICE_APP.suchbegriff" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>{{ element.searchKey }}</td>
		</ng-container>
		
		<ng-container matColumnDef="lightweight">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_SERVICE_APP.suchbegriff" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				<span>{{ element.productNo }} {{ element.shortText }}</span>
				<span>{{ element.salePrice }} / {{ element.stockUnit }}</span>
			</td>
		</ng-container>
		
		<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
		<tr (click)="highlight(row)" *matRowDef="let row; columns: displayedColumns" [ngClass]="{ highlight: (selectedProductNumber | async) == row.productNo }" mat-row></tr>
		
		<!-- Row shown when there is no matching data. -->
		<tr *matNoDataRow class="mat-row">
			<td class="mat-cell" colspan="10">
				{{ "MAIN_APP_SERVICE_APP.noDataMatchingTheFilter" | translate }} "{{ input.value }}"
			</td>
		</tr>
	</table>
	<mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="5" [showFirstLastButtons]="!lightweight"></mat-paginator>
</span>

<ng-template #lightweightList>
	<table [dataSource]="products" class="mat-elevation-z8" mat-table>
		
		<ng-container matColumnDef="lightweight">
			<th *matHeaderCellDef mat-header-cell>
				{{ "MAIN_APP_SERVICE_APP.suchbegriff" | translate }}
			</th>
			<td *matCellDef="let element" mat-cell>
				<span>{{ element.productNo }} {{ element.shortText }}</span>
				<span>{{ element.salePrice }} / {{ element.stockUnit }}</span>
			</td>
		</ng-container>
		<tr (click)="highlight(row)" *matRowDef="let row; columns: ['lightweight']" [ngClass]="{ highlight: (selectedProductNumber | async) == row.productNo }" mat-row></tr>
		
		<!-- Row shown when there is no matching data. -->
		<tr *matNoDataRow class="mat-row">
			<td class="mat-cell" colspan="10">
				{{ "MAIN_APP_SERVICE_APP.noDataMatchingTheFilter" | translate }} "{{ input.value }}"
			</td>
		</tr>
	</table>
</ng-template>